import type { PageSnapshot } from "@ai-guidance/shared";

/**
 * Semnătura ieftină a unui snapshot - NU un hash criptografic, doar destul cât
 * să distingem „pagina s-a schimbat" de „pagina e la fel". Numărul de elemente
 * pointabile + etichetele lor concatenate + lungimea textului vizibil: prinde
 * un accordion deschis, un tab schimbat, un dropdown extins (toate schimbă
 * numărul sau conținutul elementelor targetabile), fără costul unui hash real
 * pe fiecare click al vizitatorului.
 */
export function snapshotSignature(snapshot: PageSnapshot): string {
  const labels = snapshot.elements.map((el) => `${el.tag}:${el.text}`).join("|");
  return `${snapshot.elements.length}|${snapshot.text.length}|${labels}`;
}

/**
 * True dacă recaptura de după click arată o pagină material diferită de cea
 * trimisă cu întrebarea anterioară. Folosit ca gardă de cost: un click pe
 * elementul evidențiat care nu a schimbat nimic (ex. un buton dezactivat, sau
 * un reveal care s-a întâmplat deja) nu merită un apel LLM pentru un răspuns
 * identic - vezi sdk.ts.
 */
export function snapshotChanged(previous: PageSnapshot, fresh: PageSnapshot): boolean {
  return snapshotSignature(previous) !== snapshotSignature(fresh);
}
